import { fetchFluxBotAction } from "@/api/endpoints/fluxbot";
import { IStrategy } from "@/shared";

export function indexAutomations(wallet: string): Promise<any> {
	return fetchFluxBotAction(wallet, "auto_index", {
		dest: wallet,
	});
}

export function showAutomations({
	wallet,
	id,
}: {
	wallet: string;
	id: string;
}): Promise<any> {
	return fetchFluxBotAction(wallet, "auto_show", {
		data: id,
	});
}

export function createAutomation({
	wallet,
	strategy,
}: {
	wallet: string;
	strategy: IStrategy;
}): Promise<any> {
	return fetchFluxBotAction(wallet, "auto_create", {
		wallet,
		strategy,
	});
}

export function closeAutomation({
	wallet,
	id,
}: {
	wallet: string;
	id: string;
}): Promise<any> {
	return fetchFluxBotAction(wallet, "auto_cancel", {
		data: id,
	});
}
